module.exports = __webpack_public_path__ + "img/empty-files.77161c89.png";